import _ from 'lodash';
import AmpersandCollection from 'ampersand-collection';
import TodoListTemplateModel from './todo-list-template-model';

const TodoListTemplateCollection = AmpersandCollection.extend({

    model: TodoListTemplateModel,
    comparator: "sortPosition",

    filterByCompany(companyId) {
        return new TodoListTemplateCollection(this.filter(m=>m.companyId === companyId && !m.isDeleted)).sort();
    },

    resetByCompany(companyId,newData) {
        const oldTasks = this.filter(taskType=>taskType.companyId === companyId);

        _.each(oldTasks,model=>{
            this.remove(model,{ silent: true });
        });

        this.add(newData,{parse:true});
    },

    exportToOptions() {
        const templates = this.filterByCompany(gd.companyId)
        if (!templates || templates.length<1) return []

        return _.map(templates.models, (todoListTemplate)=>{
            return {
                value   : todoListTemplate.id,
                label    : todoListTemplate.name
            }
        })
    }

});

module.exports = TodoListTemplateCollection;